/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
/* eslint-disable eqeqeq */
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GlobalVariable } from '../global';
import { AlertController, LoadingController, ModalController, NavController,  NavParams } from '@ionic/angular';
import { UserApiService } from '../services/user-api.service';
import { LocalStorageService } from '../services/core/local-storage.service';
import { UserLocationPage } from '../user-location/user-location.page';
@Component({
  selector: 'app-search-user',
  templateUrl: './search-user.page.html',
  styleUrls: ['./search-user.page.scss'],
})
export class SearchUserPage implements OnInit {
  phone_number: any = '';
  name_field = false;
  email: any;
  selectedType: any;
  name: any;

  constructor(
    private router: Router,
    public globals: GlobalVariable,
    public modalController: ModalController,
    public server: UserApiService,
    public nav: NavController,
    public alertController: AlertController,
    private route: ActivatedRoute,
    public localStorageService: LocalStorageService
  ) {
    this.route.params.subscribe(params => {
      console.log(params);
      this.selectedType = params.type;
      console.log('typee', this.selectedType);
    });
    // this.selectedType = this.navParams.get('type');

    // this.selectedType = this.router.getCurrentNavigation().extras.state.type;

  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.selectedType = params.type;
      console.log('typee', this.selectedType);
    });
  }

  ionViewDidLoad() {
    if(this.selectedType == 'pickup'){
      this.globals.OrderType = 'pickup';
      this.globals.pickup == true;
      // this.globals.address.street = '';
      // this.select_type('pickup');
    }
    else{
      // this.select_type('delivery');
    }
  }

  numpad(num) {
    if (num == 'clear') {
      this.phone_number = '';
    } else if (num == 'remove') {
      let str = this.phone_number;
      str = str.slice(0, -1);
      this.phone_number = str;
    } else {
      let value = this.phone_number;
      value = value + '' + num;
      this.phone_number = value;
    }
  }

  resetPhone(){
    this.phone_number = '';
    this.name_field = false;
  }

  check_phone_number() {
    if (!this.isValidMobile(this.phone_number).invalidMobile || this.ValidateEmail(this.email)) {
      const response = this.server.checkPhoneOrEmail(this.email, this.phone_number);
      response.subscribe(data => {
        if (data.status == true) {

          this.localStorageService.setEmail('Email', data.customer_data.email);
          this.setUserData(data);

        } else {
          this.globals.presentToast('User does not exist. Enter username to signup.');
          this.name_field = true;
        }
      }, error => {
        // this.globals.presentToast("Something went wrong check your internet connection.")
      });
    } else {
      this.globals.presentToast('Please enter a valid phone number or email');
    }
  }

  isValidMobile(value): any {
    const regExp = /^[0-9]{10}$/;

    if (!regExp.test(value)) {
      return { invalidMobile: true };
    } else {
      return { invalidMobile: false };
    }
  }

  ValidateEmail(mail) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
      return true;
    }
    return false;
  }

  async seeUserLocation() {
    const modal = await this.modalController.create({
      component: UserLocationPage,
      componentProps: {},
      cssClass:'delivery_modal',
      mode:'ios',

    });
    await modal.present();
    modal.onDidDismiss().then((res) => {
      if (!res.data) {
        if (this.globals.businessData.pickup != '1' && this.globals.businessData.delivery == '1') {
          this.globals.OrderType = 'delivery';
        }
        else {
          this.globals.OrderType = 'pickup';
        }
      }
      this.nav.pop();
    });
  }

  signup() {
    if (this.isValidMobile(this.phone_number).invalidMobile || this.name == '' || this.name == undefined || this.name == null) {
      this.globals.presentToast('Please enter valid data');
    }
    else {
      const response = this.server.signup_(this.email, this.phone_number, this.name);
      response.subscribe(data => {
        console.log('Sign up -> ', data);
        if (data.status == 'true') {

          this.globals.presentToast('User Created Sucessfully');

          this.localStorageService.setEmail('Email', this.email);
          this.setUserData(data);

        } else {
          this.name_field = false;
          this.globals.presentToast(data.message);
        }
      }, error => {
        // this.globals.presentToast("Something went wrong check your internet connection.")
      });
    }
  }

  setUserData(data){
    this.localStorageService.setFirstName('FirstName', data.customer_data.first_name);
    this.localStorageService.setLastName('LastName', data.customer_data.last_name);
    this.localStorageService.setPhone('Phone', data.customer_data.phone);
    this.localStorageService.setUdId('UdId', data.udid);
    this.localStorageService.setId('Id', data.customer_data.id);
    this.localStorageService.setQrText('QrText', data.customer_data.qr_text);
    this.localStorageService.setPhoneVerified('PhoneVerified',data.customer_data.phone_verified);
    this.globals.udid = data.udid;
    this.globals.isloggedIn = true;
    this.localStorageService.setLogin('isLogin',JSON.stringify(true));

    if(this.selectedType != 'pickup'){
      this.seeUserLocation();
    }
    else{
      this.globals.presentToast('Pickup for ' + data.name + '(' + data.phone + ')');
      this.nav.pop();
      this.router.navigate(['/order']);
    }
  }

}
